import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ClassifyEffects, classifyReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([ClassifyEffects]), StoreModule.forFeature(`classify`, classifyReducer)]
})
export class ClassifyStateModule {}
